export default {
	uiEditor: {
		startBuilding: "Start Building",
		createAndLaunch:
			"Create and launch insurance products instantly. Configure pricing and underwriting rules and get auto-generated APIs. Build as many distribution apps as you need. All in nocode manner.",
		premium: "Premium",
		hkd: "HKD",
		oopsItSeemLikeYourCaseRequiresSpecialCare: "Oops, it seems like your case requires special care",
		pleaseContactOurSalesDepartmentHere: "Please contact our sales department here info@sales.com",
		content: "Content",
		design: "Design",
		props: "Properties",
		actions: "Actions",
		addAction: "+ Add Action",
		elementID: "Element ID",
		elementLabel: "Element Label",
		dataBinding: "Data Binding",
		delete: "Delete",
		style: "Style",
		addProp: "+ Add Prop",
		colors: "Colors",
		shadows: "Shadows",
		typeFaces: "Fonts",
		customCss: "Custom CSS",
		save: "Save Changes",
		cancel: "Cancel",
		addNew: "Add New",
		addNewPage: "Add New Page",
		update: "Update",
		pages: "Pages",
		tree: "Components Tree",
		edit: "Edit",
		selectToEdit: "Please Select Variant to Start Editing",
		cssInspector: "CSS Inspector",
		layer1: "Component",
		layer2: "Variant",
		layer3: "Element",
		layer4: "Key",
		layer5: "Option",
		componentThemeEditor: "Component Theme Editor",
		coverStudio: "CoverStudio",
		by: "by",
		viewport: "Viewport"
	}
}
